// src/components/ContactForm.js - UPDATED FOR NEW UI
import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
    // State for form submission status
    const [submitted, setSubmitted] = useState(false);
    
    // ⭐ REPLACE THIS with your Formspree endpoint that sends to keshavrao887@gmail.com
    const FORMSPREE_ENDPOINT = "https://formspree.io/f/mdkqbjkw"; 
    
    // Contact Details
    const WHATSAPP_NUMBER = "919790506926"; // Actual number with country code
    const DISPLAY_PHONE = "+91 9790506926"; // Display number from the image
    const PHONE_NUMBER = "+91 9790506926"; // Call number

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const form = e.target;
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { 'Accept': 'application/json' }
            });
            
            if (response.ok) {
                setSubmitted(true);
                form.reset(); 
            } else {
                alert("Failed to send inquiry. Please try again or use the contact links.");
            }
        } catch (error) {
            console.error('Submission error:', error);
            alert("An error occurred during submission.");
        }
    };
    
    const getWhatsAppLink = () => {
        return `https://wa.me/${WHATSAPP_NUMBER}?text=Hello%20Iswaran%2C%20I%20have%20an%20inquiry%20regarding...`;
    };

    return (
        <div className="contact-container">
            {/* Section Intro */}
            <div className="section-intro-contact">
                <h1 className="contact-main-title">Get in Touch</h1>
                <p className="contact-subtitle">
                    We're here to assist you with any questions or concerns. Please reach out through the 
                    channels below for a divine experience.
                </p>
            </div>
            
            {/* Main Content Grid */}
            <div className="contact-content-grid">
                
                {/* LEFT COLUMN: Send an Inquiry Form */}
                <div className="inquiry-column">
                    <h2 className="inquiry-section-title">Send an Inquiry</h2>
                    
                    <form className="contact-form" onSubmit={handleSubmit} action={FORMSPREE_ENDPOINT} method="POST">
                        <label htmlFor="name">Name</label>
                        <input 
                            type="text" 
                            id="name"
                            name="Name" 
                            placeholder="Your Full Name" 
                            className="form-input" 
                            required 
                        />
                        
                        <label htmlFor="email">Email</label>
                        <input 
                            type="email" 
                            id="email"
                            name="Email" 
                            placeholder="you@example.com" 
                            className="form-input" 
                            required 
                        />
                        
                        <label htmlFor="phone">Phone Number</label>
                        <input 
                            type="tel" 
                            id="phone"
                            name="Phone Number" 
                            placeholder="Your Phone Number" 
                            className="form-input" 
                            required 
                        />
                        
                        <label htmlFor="message">Message</label>
                        <textarea 
                            id="message"
                            name="Message" 
                            placeholder="How can we help you?" 
                            className="form-textarea" 
                            required 
                        />
                        
                        <button type="submit" className="submit-btn" disabled={submitted}>
                            {submitted ? 'Inquiry Sent!' : 'Submit Inquiry'}
                        </button>
                    </form>
                    {submitted && <p className="submit-message">We have received your inquiry and will be in touch shortly.</p>}
                </div>

                
                {/* RIGHT COLUMN: Contact Links and Delivery Info */}
                <div className="info-column">
                    <h2 className="reach-us-title">Other Ways to Reach Us</h2>
                    
                    {/* Customer Support Card */}
                    <a href={`tel:${PHONE_NUMBER}`} className="contact-card">
                        <div className="card-icon-wrapper">
                            {/* Assuming you use a common icon library like Material Icons or Font Awesome */}
                            <span className="card-icon">📞</span>
                        </div>
                        <div className="card-details">
                            <h3>Customer Support - Joseph Snowin S</h3>
                            <p>{DISPLAY_PHONE} (9am - 9pm IST)</p>
                        </div>
                        <span className="card-arrow">→</span>
                    </a>
                    
                    {/* WhatsApp Chat Card */}
                    <a 
                        href={getWhatsAppLink()} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="contact-card"
                    >
                        <div className="card-icon-wrapper">
                            <span className="card-icon">💬</span>
                        </div>
                        <div className="card-details">
                            <h3>WhatsApp Chat</h3>
                            <p>Chat with us instantly</p>
                        </div>
                        <span className="card-arrow">→</span>
                    </a>

                    {/* Delivery Information */}
                    <div className="delivery-info">
                        <h3 className="delivery-heading">Delivery Information</h3>
                        
                        <p className="delivery-text">
                            <strong className="delivery-text-bold">Within India:</strong> 
                            We ensure timely delivery of Prasad (sacred offerings) for all services performed in India.
                        </p>
                        
                        <p className="delivery-text">
                            <strong className="delivery-text-bold">International Customers:</strong> 
                            We offer digital updates and Prasad delivery options. Please note, international shipping charges are 
                            applicable and delivery times may vary based on location.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
